import React, { Component } from 'react';
import FormErrors from "../FormErrors";
import { validateForm } from "../utility";
import { Auth } from '../../Auth';

class Register extends Component {
  state = {
    username: "",
    email: "",
    password: "",
    confirmpassword: "",
    errors: {
      cognito: null,
      blankfield: false,
      passwordmatch: false
    }
  }

  clearErrorState = () => {
    this.setState({
      errors: {
        cognito: null,
        blankfield: false,
        passwordmatch: false
      }
    });
  }

  raiseError(error) {
    this.setState({
      errors: { ...this.state.errors, ...error }
    });
  }

  async store() {
    const { username, email, password } = this.state
    try {
      const auth = new Auth()
      const user = await auth.signUp({
        username: username.trim(),
        password,
        attributes: {
          email: email.trim().toLowerCase()
        }
      });
      if (user._id)
        this.props.history.push("/welcome");
      throw new Error("Algo no esta bien")
    } catch (error) {
      let err = null
      err = !error.message ? { "message": error } : error;
      this.setState({
        errors: {
          ...this.state.errors,
          cognito: err
        }
      })
    }
  }

  handleSubmit = async event => {
    event.preventDefault();
    this.clearErrorState();
    const error = validateForm(event, this.state);
    if (error) {
      this.raiseError(error)
    } else {
      this.store()
    }
  };

  onInputChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
    document.getElementById(event.target.id).classList.remove("is-danger");
  }

  render() {
    return (
      <div>
        <section className="section auth">
          <div className="container">
            <h1>REGISTRO</h1>
            <FormErrors formerrors={this.state.errors} />

            <form onSubmit={this.handleSubmit}>
              <div className="field">
                <p className="control">
                  <input
                    className="input"
                    type="text"
                    id="username"
                    aria-describedby="userNameHelp"
                    placeholder="Nombre"
                    value={this.state.username}
                    onChange={this.onInputChange}
                  />
                </p>
                <div>
                  <ul>
                    <ol><small>Nombre sin espacios</small></ol>
                  </ul>
                </div>
              </div>
              <div className="field">
                <p className="control has-icons-left has-icons-right">
                  <input
                    className="input"
                    type="email"
                    id="email"
                    aria-describedby="emailHelp"
                    placeholder="Correo electrónico"
                    value={this.state.email}
                    onChange={this.onInputChange}
                  />
                  <span className="icon is-small is-left">
                    <i className="fas fa-envelope"></i>
                  </span>
                </p>
              </div>
              <div className="field">
                <p className="control has-icons-left">
                  <input
                    className="input"
                    type="password"
                    id="password"
                    placeholder="Contraseña"
                    value={this.state.password}
                    onChange={this.onInputChange}
                  />
                  <span className="icon is-small is-left">
                    <i className="fas fa-lock"></i>
                  </span>
                </p>
                <div>
                  <ul>
                    <ol><small>Longitud mínima 8 caracteres</small></ol>
                    <ol><small>Debe tener números</small></ol>
                    <ol><small>Debe tener mayúsculas</small></ol>
                    <ol><small>Debe tener minúsculas</small></ol>
                  </ul>
                </div>
              </div>
              <div className="field">
                <p className="control has-icons-left">
                  <input
                    className="input"
                    type="password"
                    id="confirmpassword"
                    placeholder="Confirmar contraseña"
                    value={this.state.confirmpassword}
                    onChange={this.onInputChange}
                  />
                  <span className="icon is-small is-left">
                    <i className="fas fa-lock"></i>
                  </span>
                </p>
              </div>

              <div className="form-group">
                <button className="btn btn-primary">
                  REGISTRO
                </button>
              </div>
              <div className="form-group">
                <a className='btn btn-primary' href="/login">INICIO DE SESION</a>
              </div>
              <div className="form-group">
                <a href="/forgotpassword">Olvide mi clave?</a>
              </div>
            </form>
          </div>
        </section>
      </div>

    );
  }
}

export default Register;